import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './Legal.css';

function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="legal">
      <SEO
        title="Privacy Policy — Unimar Boats"
        description="Read the Unimar privacy policy to understand how we collect, use, and protect your personal data in compliance with GDPR and applicable regulations."
        url="/privacy-policy"
      />
      <Header />

      <div className="legal__hero">
        <div className="legal__hero-overlay" />
        <div className="legal__hero-content">
          <h1 className="legal__hero-title">{t('privacyPolicy.title')}</h1>
          <p className="legal__hero-sub">{t('privacyPolicy.lastUpdated')}</p>
        </div>
      </div>

      <div className="legal__body">
        <div className="legal__inner">

          <section className="legal__section">
            <h2 className="legal__section-title">{t('privacyPolicy.s1.heading')}</h2>
            <p className="legal__text">{t('privacyPolicy.s1.p1')}</p>
            <p className="legal__text">{t('privacyPolicy.s1.p2')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('privacyPolicy.s2.heading')}</h2>
            <p className="legal__text">{t('privacyPolicy.s2.intro')}</p>
            <ul className="legal__list">
              <li><strong>{t('privacyPolicy.s2.item1Label')}</strong> {t('privacyPolicy.s2.item1')}</li>
              <li><strong>{t('privacyPolicy.s2.item2Label')}</strong> {t('privacyPolicy.s2.item2')}</li>
              <li><strong>{t('privacyPolicy.s2.item3Label')}</strong> {t('privacyPolicy.s2.item3')}</li>
              <li><strong>{t('privacyPolicy.s2.item4Label')}</strong> {t('privacyPolicy.s2.item4')}</li>
            </ul>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('privacyPolicy.s3.heading')}</h2>
            <p className="legal__text">{t('privacyPolicy.s3.intro')}</p>
            <ul className="legal__list">
              <li>{t('privacyPolicy.s3.item1')}</li>
              <li>{t('privacyPolicy.s3.item2')}</li>
              <li>{t('privacyPolicy.s3.item3')}</li>
              <li>{t('privacyPolicy.s3.item4')}</li>
              <li>{t('privacyPolicy.s3.item5')}</li>
            </ul>
            <p className="legal__text">{t('privacyPolicy.s3.p')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('privacyPolicy.s4.heading')}</h2>
            <p className="legal__text">{t('privacyPolicy.s4.intro')}</p>
            <ul className="legal__list">
              <li><strong>{t('privacyPolicy.s4.item1Label')}</strong> {t('privacyPolicy.s4.item1')}</li>
              <li><strong>{t('privacyPolicy.s4.item2Label')}</strong> {t('privacyPolicy.s4.item2')}</li>
              <li><strong>{t('privacyPolicy.s4.item3Label')}</strong> {t('privacyPolicy.s4.item3')}</li>
              <li><strong>{t('privacyPolicy.s4.item4Label')}</strong> {t('privacyPolicy.s4.item4')}</li>
            </ul>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('privacyPolicy.s5.heading')}</h2>
            <p className="legal__text">{t('privacyPolicy.s5.p')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('privacyPolicy.s6.heading')}</h2>
            <p className="legal__text">{t('privacyPolicy.s6.p1')}</p>
            <ul className="legal__list">
              <li>{t('privacyPolicy.s6.item1')}</li>
              <li>{t('privacyPolicy.s6.item2')}</li>
              <li>{t('privacyPolicy.s6.item3')}</li>
            </ul>
            <p className="legal__text">{t('privacyPolicy.s6.p2')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('privacyPolicy.s7.heading')}</h2>
            <p className="legal__text">{t('privacyPolicy.s7.intro')}</p>
            <ul className="legal__list">
              <li><strong>{t('privacyPolicy.s7.item1Label')}</strong> {t('privacyPolicy.s7.item1')}</li>
              <li><strong>{t('privacyPolicy.s7.item2Label')}</strong> {t('privacyPolicy.s7.item2')}</li>
              <li><strong>{t('privacyPolicy.s7.item3Label')}</strong> {t('privacyPolicy.s7.item3')}</li>
              <li>{t('privacyPolicy.s7.item4')}</li>
              <li><strong>{t('privacyPolicy.s7.item5Label')}</strong> {t('privacyPolicy.s7.item5')}</li>
              <li><strong>{t('privacyPolicy.s7.item6Label')}</strong> {t('privacyPolicy.s7.item6')}</li>
            </ul>
            <p className="legal__text">
              {t('privacyPolicy.s7.p').split('info@unimar.com')[0]}
              <a href="mailto:info@unimar.com" className="legal__link">info@unimar.com</a>
              {t('privacyPolicy.s7.p').split('info@unimar.com')[1]}
            </p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('privacyPolicy.s8.heading')}</h2>
            <p className="legal__text">{t('privacyPolicy.s8.p')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('privacyPolicy.s9.heading')}</h2>
            <p className="legal__text">{t('privacyPolicy.s9.p')}</p>
          </section>

          <section className="legal__section">
            <h2 className="legal__section-title">{t('privacyPolicy.s10.heading')}</h2>
            <p className="legal__text">{t('privacyPolicy.s10.p')}</p>
            <p className="legal__text">
              <strong>Unimar d.o.o.</strong><br />
              Email: <a href="mailto:info@unimar.com" className="legal__link">info@unimar.com</a><br />
              Website: <a href="/" className="legal__link">unimar.com</a>
            </p>
          </section>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
